<template>
  <div class="flex-end mr-3">
    <v-select
      v-model="isDarkTheme"
      :items="themeItems"
      item-title="text"
      item-value="value"
      label="Thème"
      variant="outlined"
      density="compact"
      rounded="xl"
      hide-details="true"
      style="max-width: 200px; margin: 0 auto"
      @update:modelValue="toggleTheme($event)"
    />
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useTheme } from "vuetify";

export default {
  name: "ThemeToggle",
  setup() {
    const theme = useTheme();
    const isDarkTheme = ref(false);
    const themeItems = [
      { text: "Clair", value: false },
      { text: "Sombre", value: true },
    ];

    const toggleTheme = (value) => {
      theme.global.name.value = value ? "dark" : "light";
      localStorage.setItem("theme", value ? "dark" : "light");
      isDarkTheme.value = value;
    };

    onMounted(() => {
      const savedTheme = localStorage.getItem("theme");
      if (savedTheme) {
        isDarkTheme.value = savedTheme === "dark";
        theme.global.name.value = isDarkTheme.value ? "dark" : "light";
      }
    });

    return {
      isDarkTheme,
      themeItems,
      toggleTheme,
    };
  },
};
</script>
